<template>

<svg 
	 xmlns="http://www.w3.org/2000/svg"   
	 viewBox="-11.5 780.5 24 24" >
<path d="M0.4,802.5l-1.71-0.86l2.06-4.12l-0.58-0.29l-6.81,2.27l-0.6-1.82l4.37-1.45l-0.21-0.62l-6.42-3.21l0.86-1.71l4.12,2.06
	l0.29-0.58l-2.27-6.8l1.82-0.6l1.45,4.37l0.62-0.21l3.21-6.42l1.71,0.86l-2.06,4.12l0.58,0.29l6.81-2.27l0.6,1.82l-4.37,1.45
	l0.21,0.62l6.42,3.21l-0.86,1.71l-4.12-2.06l-0.29,0.58l2.27,6.8l-1.82,0.6l-1.45-4.37l-0.62,0.21L0.4,802.5z M0.5,794.41
	c1.06,0,1.91-0.86,1.91-1.91l0,0l0,0c0-1.06-0.86-1.91-1.91-1.91l0,0c-1.06,0-1.91,0.86-1.91,1.91l0,0l0,0
	C-1.41,793.56-0.56,794.41,0.5,794.41L0.5,794.41L0.5,794.41z"/>
</svg>

</template>